/** @format */

import { Col, Row, Grid } from "antd";
import Image from "next/image";

interface Sec4 {
  locationtypeData: any;
}

export default function Sec4({ locationtypeData }: Sec4) {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();

  return (
    <Row
      justify='center'
      style={{
        backgroundImage: "url('/bg-location.png')",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: screenSize.lg ? 140 : "",
      }}>
      <Col
        span={24}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: screenSize.lg ? 0 : "0 25px",
          margin: "30px 0",
        }}>
        <Row
          justify={"center"}
          style={{ width: "100%", gap: screenSize.lg ? 0 : "30px" }}>
          <Col
            lg={17}
            md={18}
            sm={24}
            style={{
              color: "#FFFFFF",
              fontSize: screenSize.md ? 24 : 20,
              textAlign: "center",
              borderRight: screenSize.lg
                ? "1px solid rgba(255,255,255,0.4)"
                : "",
              borderBottom: screenSize.lg
                ? ""
                : "1px solid rgba(255,255,255,0.4)",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 15,
            }}>
            <Image
              width={25}
              height={30}
              src='/location.png'
              alt='Location Image'
              style={{
                height: "25px",
                width: "20px",
                marginBottom: screenSize.lg ? "10px" : "32px",
              }}
            />

            <h5
              style={{
                fontWeight: 400,
                marginBottom: screenSize.lg ? "" : 25,
                textAlign: screenSize.lg ? "left" : "center",
              }}>
              <b>Tax Workout Group</b>
              <br />
              {locationtypeData?.acf?.address}
            </h5>
          </Col>

          <Col
            lg={7}
            md={6}
            sm={24}
            style={{
              color: "#FFFFFF",
              fontWeight: 400,
              fontSize: screenSize.md ? 24 : 20,
              textAlign: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 15,
            }}>
            <Image
              width={37}
              height={36}
              src='/phone_location.png'
              alt='Location Image'
              style={{
                height: "26px",
                width: "26px",
                objectFit: "contain",
                marginTop: "-5px",
              }}
            />
            <h5 style={{ fontWeight: 400, textAlign: "left" }}>
              <b>Contact Information</b>
              <br />
              {locationtypeData?.acf?.phone && (
                <a href='tel:3052031563' style={{ color: "white" }}>
                  {locationtypeData?.acf?.phone}
                </a>
              )}
            </h5>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
